<template>
  <div v-if="errorCondition" :class="errorClass">
    {{ errorMessage }}
  </div>
</template>

<script>
export default {
  name: 'error-message',
  props: {
    errorCondition: {
      type: Boolean,
      default: false
    },
    errorClass: { type: String, default: 'error-message' },
    errorMessage: {
      type: String,
      required: true
    }
  },
  methods: {
    ok() {
      this.$emit('okClicked', 'OK_CLICKED');
    },
    cancel() {
      this.$emit('cancelClicked', 'CANCEL_CLICKED');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.error-message {
  color: red;
}
</style>
